import { FC, memo } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
import AppIconImage from './AppIcon.png'

const AppIcon: FC<BoxProps> = props => {
  return <Box component={'img'} src={AppIconImage} {...props} />
}
export default memo(AppIcon)
